import { List, ListItem, Typography, Divider } from '@mui/material'
import { FilterRadioGroup, FilterDatePicker } from 'components/inputs/FilterFields'

const STATUS_OPTIONS = [
    { value: 'pending', text: 'Pending' },
    { value: 'paid', text: 'Paid' },
    { value: 'failed', text: 'Failed' },
    { value: 'refunded', text: 'Refunded' },
    { value: 'cancelled', text: 'Cancelled' },
]

export const PaymentListFilter = ({ filters = [], setFilters }) => {

    const handleChange = (name, data) => {
        const others = filters.filter((item) => item.field !== name)
        setFilters(others.concat(data))
    }

    return (
        <List>
            <ListItem>
                <Typography variant="h5">Filter Payments</Typography>
            </ListItem>

            <Divider flexItem />

            <ListItem>
                <FilterRadioGroup
                    name="status"
                    data={STATUS_OPTIONS}
                    label="Payment Status"
                    filters={filters}
                    onChange={handleChange}
                />
            </ListItem>

            <Divider flexItem />

            <ListItem>
                <FilterDatePicker
                    name="from_date"
                    label="From Date"
                    filters={filters}
                    onChange={handleChange}
                />
            </ListItem>

            <ListItem sx={{ py: 2 }}>
                <FilterDatePicker
                    name="to_date"
                    label="To Date"
                    filters={filters}
                    onChange={handleChange}
                />
            </ListItem>
        </List>
    )
}